/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * location configuration request
 * @export
 * @interface LocationConfigRequest
 */
export interface LocationConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof LocationConfigRequest
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigRequest
     */
    jwt?: string;
    /**
     * 
     * @type {Date}
     * @memberof LocationConfigRequest
     */
    startDate?: Date;
}

/**
 * Check if a given object implements the LocationConfigRequest interface.
 */
export function instanceOfLocationConfigRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;

    return isInstance;
}

export function LocationConfigRequestFromJSON(json: any): LocationConfigRequest {
    return LocationConfigRequestFromJSONTyped(json, false);
}

export function LocationConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationConfigRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
    };
}

export function LocationConfigRequestToJSON(value?: LocationConfigRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'jwt': value.jwt,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substring(0,10)),
    };
}

